import { DistributionModel } from '../distribution.model';
import { DistributionStyleStateEnum } from '../../../../Common/TargetingShared/enum/distribution-style-state.enum';
import { DistributionBlockTypeEnum } from '../../enums/distribution-block-type.enum';
import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import {
    distributionButtonBlockType,
    distributionDividerBlockType,
    distributionImageBlockType,
    distributionTextBlockType
} from '../../../../Common/TargetingShared/model/distribution-block-types.model';
import { RichTextDisplayElementModel } from '../../../../Common/PageBuilder/models/rich-text-display-element.model';
import { defaultDistributionStyles } from './default-distribution-styles.model';
import { ImageDisplayElementModel } from '../../../../Common/PageBuilder/models/image-display-element.model';
import { ImageDisplayElementApiModel } from '../../../../api/pagebuilder/models/image-display-element-api.model';
import { DividerDisplayElementModel } from '../../../../Common/PageBuilder/models/divider-display-element.model';
import { ButtonDisplayElementModel } from '../../../../Common/PageBuilder/models/button-display-element.model';
import { LinkModel } from '../../../../Common/Forms/models/link.model';
import { aiElement, marketingDistribution, minimalistDistribution, pressRelease } from './distribution-factory-templates';
import { AiDistributionContent } from '../../components/Distribution/AIQuickDistributionDialog/ai-quick-distribution-dialog.component';

export class DistributionFactoryModel {
    public static defaultStyles = defaultDistributionStyles;
    public static marketingDistribution = marketingDistribution;
    public static pressRelease = pressRelease;

    public static createPressReleaseDistribution(isNewBranding: boolean): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1]);

        const blocks: BlockModel [] = [];

        // eslint-disable-next-line max-len
        let url = 'https://files.agilitypr.media/media/17fa85d6-9d73-4545-b6eb-0192f65b25f7?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhLzE3ZmE4NWQ2LTlkNzMtNDU0NS1iNmViLTAxOTJmNjViMjVmNyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTcxNTd9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjI2MTE3MDE2fX19XX0_&Signature=BxzEdaZWanhZNslWPp9IY8owXhSNTRa5xreinSdtvWII1FzEK3AQ2fhKQ~wotUvj24X85GJeJUUYYKb~caOCSbisKDoxD~qGs1ykHN852PGV1Bvwu3eUDRHQUD8miEcy8U8Syyan-~qUFXlpDP7GGYiGxiaWLiXNGloh0DsmMIeGhDSqzMfpPc~hPOeJ6wiRR7Kfntq7KJz68g0AdREcyaqnyZkQHszRNATSowTdQyLXE4thExp1qfSAz~90HiXVsm-j2Kr05oHAqS81Z7UH11R1kYse9mwnPGWqAtdlWHUX3rEQrbOFxKr1Q8TkB8AU9jFn8wfzOgqb2sIwOZg2Rg__&Key-Pair-Id=K32N5FMLBYVCOF';

        if (isNewBranding) {
            url = 'https://public.agilitypr.media/187520bb-25af-4d85-8696-11b6723a01fb';
        }

        const bannerBlock = new BlockModel(
            null,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    url,
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.image]),
                    width: 2667
                }
            )
        );
        blocks.push(bannerBlock);

        const firstTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                pressRelease.firstTextBlockString.replace(/(\r?\n|\r)\s+/g, ' ').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        firstTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (firstTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (firstTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        firstTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(firstTextBlock);

        const secondTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                pressRelease.secondTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        secondTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (secondTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (secondTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        secondTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(secondTextBlock);

        // "Add Image" image
        const addImageBlock = new BlockModel(
            undefined,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    // eslint-disable-next-line max-len
                    url: 'https://files.agilitypr.media/media/d7612b95-2a16-4c96-811e-ed838a0d1dd2?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhL2Q3NjEyYjk1LTJhMTYtNGM5Ni04MTFlLWVkODM4YTBkMWRkMiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTg1MTJ9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMwNTU2OTQyfX19XX0_&Signature=QtlCvqE3IqdSO6stCSDl1H-ZpXTKQ6vRkCB6U3~XEu1RLZDssGNbCIpjRthMQkBG7McV0jRECJvdW0AQ-sDZ5B09HketgUvc3LG04fv8dFJKTplgV9otjKAs9LZZvCOB6z8-9bOnHQw3HehGeb9bfNf9-h5GpOJvQBkFIFIc2gDoS959EJIMcPLAoFO9Cd1g2R9QH2okBS23miCKZ5ll6p2jqzW8pvccwOBR-RW2f5i~b8AROPtmKMP6s7GDdYhxu1z34iVhM~9NMITm3iTtVJaY4v~svUIhwuEksY9MTRPCUUNQe10wJR4-KhSac151ib0-60JwIXrE0l7Rx20FNw__&Key-Pair-Id=K32N5FMLBYVCOF',
                    // eslint-disable-next-line max-len
                    caption: 'Captioning your images is a recommended approach to improve accessibility.',
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.image]),
                    width: 2505
                }
            )
        );
        addImageBlock.displayElement.styles.isBoundToGlobalStyles = true;
        addImageBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(addImageBlock);

        const dividerBlock = new BlockModel(
            null,
            distributionDividerBlockType,
            new DividerDisplayElementModel(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.divider])
        );
        dividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
        dividerBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(dividerBlock);

        const thirdTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                pressRelease.thirdTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )

        );
        thirdTextBlock.displayElement.styles.isBoundToGlobalStyles = false;
        (thirdTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (thirdTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        thirdTextBlock.displayElement.isBoundToGlobalStyles = false;
        blocks.push(thirdTextBlock);

        // eslint:enable:max-line-length

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }

    public static createMinimalistDistribution(): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3]);
        const blocks: BlockModel [] = [];

        const firstTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                minimalistDistribution.firstTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.text])
            )
        );
        firstTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (firstTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (firstTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        firstTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(firstTextBlock);

        const secondTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                minimalistDistribution.secondTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.text])
            )
        );
        secondTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (secondTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (secondTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        secondTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(secondTextBlock);

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }

    public static createMarketingDistribution(isNewBranding: boolean): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4]);
        const blocks: BlockModel [] = [];

        // eslint-disable-next-line max-len
        let url = 'https://files.agilitypr.media/media/5ba7d935-2aaa-4035-ac6e-8f1e00413afb?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhLzViYTdkOTM1LTJhYWEtNDAzNS1hYzZlLThmMWUwMDQxM2FmYiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTg1MTJ9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMwNTU2OTAyfX19XX0_&Signature=Kq~0~J0guBLkfaj7EIR-7FDxyOn6ispK9o6GpzclGPjfiVg9McTt7pxBABaKTYt~v-mnm2ZJNkc2DxhtZMeF6wjZg19dFMnMbhMAioVZEODwulRU8VRlXehltn4OtmZrzNemcEgrwBNa7yL7f0X8aziVqKjWUX5g2n2TUIjdXQbBGsDnnnNh7oDMlzYyYVnOQ2HjgNQNLZm3U85Towa3QWffajwxCZNyKFCY2XIvOvUyP7TpdDqtA7nRYDhHghbCQZWsclONBFlw1QGsN2b9csHZDUqrRza6GP1FsiKbZKD7sZIS7YE7D-vWxt~CTmlLgcRwRH4yIsVjhdDSeuXZ4g__&Key-Pair-Id=K32N5FMLBYVCOF';

        if (isNewBranding) {
            url = 'https://public.agilitypr.media/e300d98b-4779-4075-9d53-c8ef236d3bd8';
        }

        const bannerImageBlock = new BlockModel(
            undefined,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    url,
                    caption: null,
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_5][DistributionBlockTypeEnum.image]),
                    width: 2835
                }
            )
        );
        bannerImageBlock.displayElement.styles.isBoundToGlobalStyles = false;
        bannerImageBlock.displayElement.isBoundToGlobalStyles = false;
        blocks.push(bannerImageBlock);

        const firstTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                this.marketingDistribution.firstTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        firstTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (firstTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (firstTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        firstTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(firstTextBlock);

        const secondTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                this.marketingDistribution.secondTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        secondTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (secondTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (secondTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        secondTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(secondTextBlock);

        const thirdTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                this.marketingDistribution.thirdTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        thirdTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (thirdTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (thirdTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        thirdTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(thirdTextBlock);

        // "Add Image" image
        const addImageBlock = new BlockModel(
            undefined,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    // eslint-disable-next-line max-len
                    url: 'https://files.agilitypr.media/media/d7612b95-2a16-4c96-811e-ed838a0d1dd2?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhL2Q3NjEyYjk1LTJhMTYtNGM5Ni04MTFlLWVkODM4YTBkMWRkMiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTg1MTJ9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMwNTU2OTQyfX19XX0_&Signature=QtlCvqE3IqdSO6stCSDl1H-ZpXTKQ6vRkCB6U3~XEu1RLZDssGNbCIpjRthMQkBG7McV0jRECJvdW0AQ-sDZ5B09HketgUvc3LG04fv8dFJKTplgV9otjKAs9LZZvCOB6z8-9bOnHQw3HehGeb9bfNf9-h5GpOJvQBkFIFIc2gDoS959EJIMcPLAoFO9Cd1g2R9QH2okBS23miCKZ5ll6p2jqzW8pvccwOBR-RW2f5i~b8AROPtmKMP6s7GDdYhxu1z34iVhM~9NMITm3iTtVJaY4v~svUIhwuEksY9MTRPCUUNQe10wJR4-KhSac151ib0-60JwIXrE0l7Rx20FNw__&Key-Pair-Id=K32N5FMLBYVCOF',
                    caption: 'Tell your image\'s story in words.',
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.image]),
                    width: 560
                }
            )
        );
        addImageBlock.displayElement.styles.isBoundToGlobalStyles = true;
        addImageBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(addImageBlock);

        const firstDividerBlock = new BlockModel(
            undefined,
            distributionDividerBlockType,
            new DividerDisplayElementModel(
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.divider])
            )
        );
        firstDividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
        firstDividerBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(firstDividerBlock);

        const buttonBlock = new BlockModel(
            undefined,
            distributionButtonBlockType,
            new ButtonDisplayElementModel(
                'LEARN MORE',
                new LinkModel({url: 'https://www.agilitypr.com/resources/'}),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.button])
            )
        );
        buttonBlock.displayElement.styles.isBoundToGlobalStyles = true;
        buttonBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(buttonBlock);

        const fourthTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                this.marketingDistribution.fourthTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        fourthTextBlock.displayElement.styles.isBoundToGlobalStyles = true;
        (fourthTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (fourthTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        fourthTextBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(fourthTextBlock);

        const fifthTextBlock = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                this.marketingDistribution.fifthTextBlockString.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_5][DistributionBlockTypeEnum.text])
            )
        );
        fifthTextBlock.displayElement.styles.isBoundToGlobalStyles = false;
        (fifthTextBlock.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (fifthTextBlock.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        fifthTextBlock.displayElement.isBoundToGlobalStyles = false;
        blocks.push(fifthTextBlock);

        const secondDividerBlock = new BlockModel(
            undefined,
            distributionDividerBlockType,
            new DividerDisplayElementModel(
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_5][DistributionBlockTypeEnum.divider])
            )
        );
        secondDividerBlock.displayElement.styles.isBoundToGlobalStyles = false;
        secondDividerBlock.displayElement.isBoundToGlobalStyles = false;
        blocks.push(secondDividerBlock);

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }

    public static createAiBlankDistribution(
        isNewBranding: boolean,
        aiContent: AiDistributionContent,
        isPressRelease: boolean,
        aiReferenceId: string
    ): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();
        newDistribution.aiReferenceId = aiReferenceId;

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DEFAULT]);
        const blocks: BlockModel [] = [];

        if (isPressRelease) {
            const forImmediateReleaseText = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel(
                    aiElement.forImmediateReleaseText.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                    JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.text])
                )
            );
            forImmediateReleaseText.displayElement.styles.isBoundToGlobalStyles = true;
            (forImmediateReleaseText.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (forImmediateReleaseText.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            forImmediateReleaseText.displayElement.isBoundToGlobalStyles = true;
            blocks.push(forImmediateReleaseText);
        }

        const headline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.headline.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.headline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.text])
            )
        );
        headline.displayElement.styles.isBoundToGlobalStyles = true;
        (headline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (headline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        headline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(headline);

        const subHeadline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.subHeadline.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.subHeadline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.text])
            )
        );
        subHeadline.displayElement.styles.isBoundToGlobalStyles = true;
        (subHeadline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (subHeadline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        subHeadline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(subHeadline);

        const body = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(aiElement.body.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.body),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.text])
            )
        );
        body.displayElement.styles.isBoundToGlobalStyles = true;
        (body.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (body.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        body.displayElement.isBoundToGlobalStyles = true;
        blocks.push(body);

        if (isPressRelease) {
            const dividerBlock = new BlockModel(
                null,
                distributionDividerBlockType,
                new DividerDisplayElementModel(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.divider])
            );
            dividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
            dividerBlock.displayElement.isBoundToGlobalStyles = true;

            blocks.push(dividerBlock);

            const aboutUs = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel(
                    aiElement.aboutUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.aboutUs),
                    JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.text])
                )
            );
            aboutUs.displayElement.styles.isBoundToGlobalStyles = true;
            (aboutUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (aboutUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            aboutUs.displayElement.isBoundToGlobalStyles = true;
            blocks.push(aboutUs);

            const contactUs = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel(
                    aiElement.contactUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.contactUs),
                    JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DEFAULT][DistributionBlockTypeEnum.text])
                )
            );
            contactUs.displayElement.styles.isBoundToGlobalStyles = true;
            (contactUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (contactUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            contactUs.displayElement.isBoundToGlobalStyles = true;
            blocks.push(contactUs);
        }

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }

    public static createAiPressReleaseDistribution(
        isNewBranding: boolean,
        aiContent: AiDistributionContent,
        isPressRelease: boolean,
        aiReferenceId: string
    ): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();
        newDistribution.aiReferenceId = aiReferenceId;

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1]);
        const blocks: BlockModel [] = [];

        // eslint-disable-next-line max-len
        let url = 'https://files.agilitypr.media/media/17fa85d6-9d73-4545-b6eb-0192f65b25f7?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhLzE3ZmE4NWQ2LTlkNzMtNDU0NS1iNmViLTAxOTJmNjViMjVmNyIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTcxNTd9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjI2MTE3MDE2fX19XX0_&Signature=BxzEdaZWanhZNslWPp9IY8owXhSNTRa5xreinSdtvWII1FzEK3AQ2fhKQ~wotUvj24X85GJeJUUYYKb~caOCSbisKDoxD~qGs1ykHN852PGV1Bvwu3eUDRHQUD8miEcy8U8Syyan-~qUFXlpDP7GGYiGxiaWLiXNGloh0DsmMIeGhDSqzMfpPc~hPOeJ6wiRR7Kfntq7KJz68g0AdREcyaqnyZkQHszRNATSowTdQyLXE4thExp1qfSAz~90HiXVsm-j2Kr05oHAqS81Z7UH11R1kYse9mwnPGWqAtdlWHUX3rEQrbOFxKr1Q8TkB8AU9jFn8wfzOgqb2sIwOZg2Rg__&Key-Pair-Id=K32N5FMLBYVCOF';

        if (isNewBranding) {
            url = 'https://public.agilitypr.media/187520bb-25af-4d85-8696-11b6723a01fb';
        }

        const bannerBlock = new BlockModel(
            null,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    url,
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.image]),
                    width: 2667
                }
            )
        );
        blocks.push(bannerBlock);

        const forImmediateReleaseText = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.pressReleaseForImmediateReleaseText.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        forImmediateReleaseText.displayElement.styles.isBoundToGlobalStyles = true;
        (forImmediateReleaseText.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (forImmediateReleaseText.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        forImmediateReleaseText.displayElement.isBoundToGlobalStyles = true;
        blocks.push(forImmediateReleaseText);

        const headline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.headline.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.headline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        headline.displayElement.styles.isBoundToGlobalStyles = true;
        (headline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (headline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        headline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(headline);

        const subHeadline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.subHeadline.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.subHeadline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        subHeadline.displayElement.styles.isBoundToGlobalStyles = true;
        (subHeadline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (subHeadline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        subHeadline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(subHeadline);

        const body = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel( aiElement.body.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.body),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        body.displayElement.styles.isBoundToGlobalStyles = true;
        (body.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (body.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        body.displayElement.isBoundToGlobalStyles = true;
        blocks.push(body);

        // "Add Image" image
        const addImageBlock = new BlockModel(
            undefined,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    // eslint-disable-next-line max-len
                    url: 'https://files.agilitypr.media/media/d7612b95-2a16-4c96-811e-ed838a0d1dd2?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhL2Q3NjEyYjk1LTJhMTYtNGM5Ni04MTFlLWVkODM4YTBkMWRkMiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTg1MTJ9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMwNTU2OTQyfX19XX0_&Signature=QtlCvqE3IqdSO6stCSDl1H-ZpXTKQ6vRkCB6U3~XEu1RLZDssGNbCIpjRthMQkBG7McV0jRECJvdW0AQ-sDZ5B09HketgUvc3LG04fv8dFJKTplgV9otjKAs9LZZvCOB6z8-9bOnHQw3HehGeb9bfNf9-h5GpOJvQBkFIFIc2gDoS959EJIMcPLAoFO9Cd1g2R9QH2okBS23miCKZ5ll6p2jqzW8pvccwOBR-RW2f5i~b8AROPtmKMP6s7GDdYhxu1z34iVhM~9NMITm3iTtVJaY4v~svUIhwuEksY9MTRPCUUNQe10wJR4-KhSac151ib0-60JwIXrE0l7Rx20FNw__&Key-Pair-Id=K32N5FMLBYVCOF',
                    // eslint-disable-next-line max-len
                    caption: 'Captioning your images is a recommended approach to improve accessibility.',
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.image]),
                    width: 2505
                }
            )
        );
        addImageBlock.displayElement.styles.isBoundToGlobalStyles = true;
        addImageBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(addImageBlock);

        const dividerBlock = new BlockModel(
            null,
            distributionDividerBlockType,
            new DividerDisplayElementModel(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.divider])
        );
        dividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
        dividerBlock.displayElement.isBoundToGlobalStyles = true;

        blocks.push(dividerBlock);

        const aboutUs = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.aboutUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.aboutUs),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        aboutUs.displayElement.styles.isBoundToGlobalStyles = true;
        (aboutUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (aboutUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        aboutUs.displayElement.isBoundToGlobalStyles = true;
        blocks.push(aboutUs);

        const contactUs = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.contactUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.contactUs),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_1][DistributionBlockTypeEnum.text])
            )
        );
        contactUs.displayElement.styles.isBoundToGlobalStyles = true;
        (contactUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (contactUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        contactUs.displayElement.isBoundToGlobalStyles = true;
        blocks.push(contactUs);

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }

    public static createAiMinimalistDistribution(
        isNewBranding: boolean,
        aiContent: AiDistributionContent,
        isPressRelease: boolean,
        aiReferenceId: string
    ): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();
        newDistribution.aiReferenceId = aiReferenceId;

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3]);
        const blocks: BlockModel [] = [];

        const headline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                (isPressRelease ? aiElement.minimalistHeadline : aiElement.minimalistEmailHeadline)
                    .replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.headline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.text])
            )
        );
        headline.displayElement.styles.isBoundToGlobalStyles = true;
        (headline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (headline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        headline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(headline);

        const body = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(aiElement.body.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.body),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.text])
            )
        );
        body.displayElement.styles.isBoundToGlobalStyles = true;
        (body.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (body.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        body.displayElement.isBoundToGlobalStyles = true;
        blocks.push(body);

        if (isPressRelease) {
            const dividerBlock = new BlockModel(
                null,
                distributionDividerBlockType,
                new DividerDisplayElementModel(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.divider])
            );
            dividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
            dividerBlock.displayElement.isBoundToGlobalStyles = true;

            blocks.push(dividerBlock);

            const aboutUs = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel(
                    aiElement.aboutUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.aboutUs),
                    JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.text])
                )
            );
            aboutUs.displayElement.styles.isBoundToGlobalStyles = true;
            (aboutUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (aboutUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            aboutUs.displayElement.isBoundToGlobalStyles = true;
            blocks.push(aboutUs);

            const contactUs = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel(
                    aiElement.contactUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.contactUs),
                    JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_3][DistributionBlockTypeEnum.text])
                )
            );
            contactUs.displayElement.styles.isBoundToGlobalStyles = true;
            (contactUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (contactUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            contactUs.displayElement.isBoundToGlobalStyles = true;
            blocks.push(contactUs);
        }

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }

    public static createAiMarketingDistribution(
        isNewBranding: boolean,
        aiContent: AiDistributionContent,
        isPressRelease: boolean,
        aiReferenceId: string
    ): DistributionModel {
        const newDistribution: DistributionModel = new DistributionModel();
        newDistribution.aiReferenceId = aiReferenceId;

        newDistribution.getFooterBlock().displayElement.styles =
            this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.footer];

        newDistribution.generalStyles.setStyles(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4]);
        const blocks: BlockModel [] = [];

        // eslint-disable-next-line max-len
        let url = 'https://files.agilitypr.media/media/5ba7d935-2aaa-4035-ac6e-8f1e00413afb?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhLzViYTdkOTM1LTJhYWEtNDAzNS1hYzZlLThmMWUwMDQxM2FmYiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTg1MTJ9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMwNTU2OTAyfX19XX0_&Signature=Kq~0~J0guBLkfaj7EIR-7FDxyOn6ispK9o6GpzclGPjfiVg9McTt7pxBABaKTYt~v-mnm2ZJNkc2DxhtZMeF6wjZg19dFMnMbhMAioVZEODwulRU8VRlXehltn4OtmZrzNemcEgrwBNa7yL7f0X8aziVqKjWUX5g2n2TUIjdXQbBGsDnnnNh7oDMlzYyYVnOQ2HjgNQNLZm3U85Towa3QWffajwxCZNyKFCY2XIvOvUyP7TpdDqtA7nRYDhHghbCQZWsclONBFlw1QGsN2b9csHZDUqrRza6GP1FsiKbZKD7sZIS7YE7D-vWxt~CTmlLgcRwRH4yIsVjhdDSeuXZ4g__&Key-Pair-Id=K32N5FMLBYVCOF';

        if (isNewBranding) {
            url = 'https://public.agilitypr.media/e300d98b-4779-4075-9d53-c8ef236d3bd8';
        }

        const bannerImageBlock = new BlockModel(
            undefined,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    url,
                    caption: null,
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_5][DistributionBlockTypeEnum.image]),
                    width: 2835
                }
            )
        );
        bannerImageBlock.displayElement.styles.isBoundToGlobalStyles = false;
        bannerImageBlock.displayElement.isBoundToGlobalStyles = false;
        blocks.push(bannerImageBlock);

        const forImmediateReleaseText = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.marketingForImmediateReleaseText.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>'),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        forImmediateReleaseText.displayElement.styles.isBoundToGlobalStyles = true;
        (forImmediateReleaseText.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (forImmediateReleaseText.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        forImmediateReleaseText.displayElement.isBoundToGlobalStyles = true;
        blocks.push(forImmediateReleaseText);

        const headline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                (isPressRelease ? aiElement.marketingHeadline : aiElement.marketingEmailHeadline)
                    .replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.headline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        headline.displayElement.styles.isBoundToGlobalStyles = true;
        (headline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (headline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        headline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(headline);

        const subHeadline = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.marketingSubHeadline.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.subHeadline),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        subHeadline.displayElement.styles.isBoundToGlobalStyles = true;
        (subHeadline.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (subHeadline.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        subHeadline.displayElement.isBoundToGlobalStyles = true;
        blocks.push(subHeadline);

        if (!isPressRelease) {
            const marketingPitch = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel( aiElement.marketingPitch
                    .replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.marketingPitch),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
                )
            );
            marketingPitch.displayElement.styles.isBoundToGlobalStyles = true;
            (marketingPitch.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (marketingPitch.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            marketingPitch.displayElement.isBoundToGlobalStyles = true;
            blocks.push(marketingPitch);
        }

        const body = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel( aiElement.body.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.body),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
            )
        );
        body.displayElement.styles.isBoundToGlobalStyles = true;
        (body.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (body.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        body.displayElement.isBoundToGlobalStyles = true;
        blocks.push(body);

        // "Add Image" image
        const addImageBlock = new BlockModel(
            undefined,
            distributionImageBlockType,
            new ImageDisplayElementModel (
                <ImageDisplayElementApiModel> {
                    // eslint-disable-next-line max-len
                    url: 'https://files.agilitypr.media/media/d7612b95-2a16-4c96-811e-ed838a0d1dd2?Policy=eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vZmlsZXMuYWdpbGl0eXByLm1lZGlhL21lZGlhL2Q3NjEyYjk1LTJhMTYtNGM5Ni04MTFlLWVkODM4YTBkMWRkMiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MzI0Mjk4MTg1MTJ9LCJJcEFkZHJlc3MiOnsiQVdTOlNvdXJjZUlwIjoiMC4wLjAuMC8wIn0sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMwNTU2OTQyfX19XX0_&Signature=QtlCvqE3IqdSO6stCSDl1H-ZpXTKQ6vRkCB6U3~XEu1RLZDssGNbCIpjRthMQkBG7McV0jRECJvdW0AQ-sDZ5B09HketgUvc3LG04fv8dFJKTplgV9otjKAs9LZZvCOB6z8-9bOnHQw3HehGeb9bfNf9-h5GpOJvQBkFIFIc2gDoS959EJIMcPLAoFO9Cd1g2R9QH2okBS23miCKZ5ll6p2jqzW8pvccwOBR-RW2f5i~b8AROPtmKMP6s7GDdYhxu1z34iVhM~9NMITm3iTtVJaY4v~svUIhwuEksY9MTRPCUUNQe10wJR4-KhSac151ib0-60JwIXrE0l7Rx20FNw__&Key-Pair-Id=K32N5FMLBYVCOF',
                    caption: 'Tell your image\'s story in words.',
                    styles: JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.image]),
                    width: 560
                }
            )
        );
        addImageBlock.displayElement.styles.isBoundToGlobalStyles = true;
        addImageBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(addImageBlock);

        const firstDividerBlock = new BlockModel(
            undefined,
            distributionDividerBlockType,
            new DividerDisplayElementModel(
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.divider])
            )
        );
        firstDividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
        firstDividerBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(firstDividerBlock);

        const buttonBlock = new BlockModel(
            undefined,
            distributionButtonBlockType,
            new ButtonDisplayElementModel(
                'LEARN MORE',
                new LinkModel({url: 'https://www.agilitypr.com/resources/'}),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.button])
            )
        );
        buttonBlock.displayElement.styles.isBoundToGlobalStyles = true;
        buttonBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(buttonBlock);

        if (!isPressRelease) {
            const marketingPitch = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel( aiElement.marketingConclusion.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>')
                    .replace('{{aiContent}}', aiContent.marketingConclusion),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.text])
                )
            );
            marketingPitch.displayElement.styles.isBoundToGlobalStyles = true;
            (marketingPitch.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (marketingPitch.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            marketingPitch.displayElement.isBoundToGlobalStyles = true;
            blocks.push(marketingPitch);
        }

        const aboutUs = new BlockModel(
            null,
            distributionTextBlockType,
            new RichTextDisplayElementModel(
                aiElement.marketingAboutUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.aboutUs),
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_5][DistributionBlockTypeEnum.text])
            )
        );
        aboutUs.displayElement.styles.isBoundToGlobalStyles = true;
        (aboutUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
        (aboutUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
        aboutUs.displayElement.isBoundToGlobalStyles = true;
        blocks.push(aboutUs);

        if (isPressRelease) {
            const contactUs = new BlockModel(
                null,
                distributionTextBlockType,
                new RichTextDisplayElementModel(
                    aiElement.marketingContactUs.replace(/(\r?\n|\r)\s+/g, '').replace(/>\s+/g, '>').replace('{{aiContent}}', aiContent.contactUs),
                    JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_5][DistributionBlockTypeEnum.text])
                )
            );
            contactUs.displayElement.styles.isBoundToGlobalStyles = true;
            (contactUs.displayElement as RichTextDisplayElementModel).enableAIHelper = true;
            (contactUs.displayElement as RichTextDisplayElementModel).aiReferenceId = newDistribution.aiReferenceId;
            contactUs.displayElement.isBoundToGlobalStyles = true;
            blocks.push(contactUs);
        }

        const secondDividerBlock = new BlockModel(
            undefined,
            distributionDividerBlockType,
            new DividerDisplayElementModel(
                JSON.stringify(this.defaultStyles[DistributionStyleStateEnum.DISTRIBUTION_4][DistributionBlockTypeEnum.divider])
            )
        );
        secondDividerBlock.displayElement.styles.isBoundToGlobalStyles = true;
        secondDividerBlock.displayElement.isBoundToGlobalStyles = true;
        blocks.push(secondDividerBlock);

        newDistribution.blocks.unshift(...blocks);

        return newDistribution;
    }
}
